/**
 * ErpIntegrationTabs — ekran „Integracja ERP" w modelu MASTER-DETAIL.
 *
 * Wcześniej: 6 GLOBALNYCH zakładek (Konfiguracja / Synchronizacja / Historia / Mapowania /
 * Dokumenty / Instrukcja), z których każda operacyjna pokazywała WSZYSTKIE integracje naraz
 * — myliło przy kilku integracjach (Handel + FK). Teraz:
 *   - MASTER = lista integracji (`IntegrationsTab`): tworzenie, edycja, usuwanie + „Otwórz".
 *   - DETAIL = po wejściu w jedną integrację jej WŁASNE zakładki, zawężone do niej
 *     (`IntegrationDetail`), z zestawem zależnym od typu ERP (Dokumenty tylko dla FK).
 *
 * Zmiana czysto frontendowa — reużywa istniejące komponenty zakładek w trybie „pojedynczej
 * integracji" (prop `integrationId`).
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IntegrationDetail } from './IntegrationDetail';
import { IntegrationsTab } from './IntegrationsTab';

export function ErpIntegrationTabs() {
  const { t } = useTranslation();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (selectedId) {
    return <IntegrationDetail integrationId={selectedId} onBack={() => setSelectedId(null)} />;
  }

  return (
    <div>
      <header className="mb-4">
        <h2 className="text-lg font-semibold text-text-primary">
          {t('tenant.settings.integrations.screen.title')}
        </h2>
        <p className="mt-1 text-sm text-text-secondary">
          {t('tenant.settings.integrations.screen.subtitle')}
        </p>
      </header>

      <IntegrationsTab hideTitle onOpen={setSelectedId} />
    </div>
  );
}
